import useMountedQuery from 'Hooks/useMountedQuery';
import { countUserTypes } from 'Queries/GraphQlQueries/Account/AccountQueries';

export const useCountUserTypes = () => (
	useMountedQuery(
		countUserTypes,
		[],
	)
);
